module.exports = __webpack_public_path__ + "static/media/MODO_NORMAL.bbd01434.jpg";